import styled, { css } from "styled-components";
import Form from 'react-bootstrap/Form';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

export const NumberInput = styled(Form.Control)`
  background-color: #ececec;
  width: 3rem;
`;

const iconStyle = css`
  cursor: pointer;
`;

export const FaChevronUpIcon = styled(FaChevronUp)`
  ${iconStyle}
`;

export const FaChevronDownIcon = styled(FaChevronDown)`
  ${iconStyle}
`;

export const InputContainer = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
